import { useFormSubmissionController } from '@melio/penny';
import { Account, EbillsSubscriptionOptions, Vendor } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import { useMonitoring } from '@melio/platform-monitoring';

import type { MonitoredAction } from '../../../../../monitoring';
import { NewSinglePaymentStepLayout } from '../../../../NewSinglePaymentStepLayout';
import { EBillsSusbscriptionForm } from './EBillsSusbscriptionForm';
import { EbillsSubscriptionFormFields } from './types';

export const EBillsSusbscriptionFormScreen = ({
  vendor,
  account,
  ebillsSubscriptionOptions,
  onSubmit,
  onClose,
  isSaving,
}: {
  vendor: Vendor;
  account: Account;
  ebillsSubscriptionOptions: EbillsSubscriptionOptions;
  onSubmit: (data: EbillsSubscriptionFormFields) => void;
  onClose: () => void;
  isSaving: boolean;
}) => {
  const { submitButtonProps, onSubmissionStateChange } = useFormSubmissionController<EbillsSubscriptionFormFields>();
  const { formatMessage } = useMelioIntl();
  const { routeReady } = useMonitoring<MonitoredAction>();

  return (
    <NewSinglePaymentStepLayout
      ref={routeReady}
      data-testid="ebills-subscription-form"
      headerContent={
        <NewSinglePaymentStepLayout.Header>
          <NewSinglePaymentStepLayout.CloseButton onClick={onClose} />
        </NewSinglePaymentStepLayout.Header>
      }
      footerContent={
        <NewSinglePaymentStepLayout.Actions>
          <NewSinglePaymentStepLayout.NextButton
            {...submitButtonProps}
            data-testid="ebills-subscription-form-submit-button"
            label={formatMessage('activities.ebillsSubscriptionForm.form.submit.label')}
          />
        </NewSinglePaymentStepLayout.Actions>
      }
    >
      <NewSinglePaymentStepLayout.Title>
        {formatMessage('activities.ebillsSubscriptionForm.form.title', { vendorName: vendor?.name })}
      </NewSinglePaymentStepLayout.Title>
      <NewSinglePaymentStepLayout.Description>
        {formatMessage('activities.ebillsSubscriptionForm.form.description')}
      </NewSinglePaymentStepLayout.Description>
      <NewSinglePaymentStepLayout.Content>
        <EBillsSusbscriptionForm
          vendor={vendor}
          account={account}
          ebillsSubscriptionOptions={ebillsSubscriptionOptions}
          onSubmit={onSubmit}
          onSubmissionStateChange={onSubmissionStateChange}
          isSaving={isSaving}
        />
      </NewSinglePaymentStepLayout.Content>
    </NewSinglePaymentStepLayout>
  );
};
